import { render, staticRenderFns } from "./tallybill-record.vue?vue&type=template&id=8329d9f8&"
import script from "./tallybill-record.vue?vue&type=script&lang=ts&"
export * from "./tallybill-record.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports